/**
 * Collapsible Slice
 * Manages which collapsible panel is expanded (held calls or conference).
 * Only one panel can be open at a time.
 */
import type { StateCreator } from 'zustand';
import { SoftphoneStore } from '../..';
import { CollapsibleSlice, CollapsibleSliceState } from './index.types';

const initialState: CollapsibleSliceState = {
  expandedCollapsible: null,
};

export const createCollapsibleSlice: StateCreator<
  SoftphoneStore,
  [],
  [],
  CollapsibleSlice
> = (set, get) => ({
  ...initialState,

  toggleCollapsible: (panel) => {
    const current = get().expandedCollapsible;
    set({ expandedCollapsible: current === panel ? null : panel });
  },

  closeCollapsible: () => {
    set({ expandedCollapsible: null });
  },
});
